import {
  Component,
  OnInit,
  ViewEncapsulation,
  AfterViewInit,
  HostListener,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { RootLayout } from '../root/root.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { pagesToggleService } from '../../services/toggler.service';
import { Router, ActivatedRoute, ActivationEnd } from '@angular/router';
import {
  PhotoGalleryService,
  PropertySharedService,
  CurrentUserService,
  GetMeNotifiedService,
  GeneralService
} from '@shared/services';
import { Property } from '@shared/api/property/property.model';
import { PhotoViewerService } from '@shared/services/photo-viewer/photo-viewer.service';
import { Users } from '@shared/api/users/users.model';
import { VideoPlayerService, WalletSharedService } from '@shared/services';
import { SessionStorageService } from '@shared/services/session-storage/session-storage.service';
import { HomeVideoService } from '@shared/services/home-video-service/home-video.service';
import { UsersService } from '@shared/api';
import { VERIFICATION_STATUS } from '@shared/constants/verification-status';
import { PROPERTY_STATUS } from '@shared/constants/property-details';
import { BsModalService } from 'ngx-bootstrap';
import { OrderPropertyModalComponent } from '@shared/components/modals/order-property-modal/order-property-modal.component';
import {
  ConfirmationComponent,
  ConfirmationProps
} from '@shared/components/modals/confirmation';
import { InvestorVerificationComponent } from '@shared/components/modals/investor-verification/investor-verification.component';
import { AddFundsComponent } from '@shared/components/modals/add-funds/add-funds.component';
declare var pg: any;
@Component({
  selector: 'executive-layout',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1, display: 'inline-block' }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms', style({ opacity: 0, display: 'none' }))
      ])
    ])
  ],
  templateUrl: './executive.component.html',
  styleUrls: ['./executive.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExecutiveLayout extends RootLayout
  implements OnInit, AfterViewInit, OnDestroy {
  menuItems: any;
  galleryOpen = false;
  viewerOpen = false;
  playerOpen = false;
  homeVideoOpen = false;
  openNotifiedModal = false;

  // Property Details Button
  propertyId: number;
  isPreOrderButtonShow: boolean = false;
  isDetailsReady: boolean = false;
  details: Property;
  isNotAllow: boolean = false;

  // Wallet Funds Button
  isWalletButtonShow: boolean = false;

  // Add Property Button
  isAddPropertyButtonShow: boolean = false;

  header: any;
  menuBar: any;
  logoContainer: any;
  headerHeight = 0;
  menuBarHeight = 0;
  logoContainerHeight = 0;
  tabletViewMaxSize = 991;
  tabletViewMinSize = 426;
  desktopView;
  tabletView;
  mobileView;
  // moduleChecker: any;
  isMenuMinimize = false;
  usersInfo: Users;
  isLogin: boolean = false;

  isScrollHidden = false; // executive Emmit hideScroll to how does it work

  @HostListener(' scroll', ['$event'])
  onScroll(evt) {
    setTimeout(() => {
      if (window.innerWidth <= this.tabletViewMaxSize) {
        this.header.style = null;
        return;
      }
      if (evt.target.scrollTop > this.header.clientHeight) {
        // this.header.style.height = `${this.menuBarHeight}px`;
        this.header.style.height = `41px`;
        this.logoContainer.style.height = `0px`;
        this.logoContainer.style.overflow = `hidden`;
        this.isMenuMinimize = true;
      } else {
        // this.header.style.height = `${this.headerHeight}px`;
        this.header.style.height = `101px`;
        this.logoContainer.style.height = `${(this.logoContainerHeight >= 60 &&
          this.logoContainerHeight) ||
          60}px`;
        this.logoContainer.style.overflow = `initial`;
        this.isMenuMinimize = false;
      }
    }, 300);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (!this.isMenuMinimize) {
      setTimeout(() => {
        this.header.style = null;
        this.checkViewPorts();
        this.checkMenuDimensions();
      }, 500);
    }
    setTimeout(() => {
      this.header.style = null;
      this.checkViewPorts();
      this.checkMenuDimensions();
    }, 500);
  }

  constructor(
    public _toggler: pagesToggleService,
    private _router: Router,
    private _photoGalleryService: PhotoGalleryService,
    private activeRouter: ActivatedRoute,
    private modalService: BsModalService,
    private _propertyShared: PropertySharedService,
    private _photoViewerService: PhotoViewerService,
    private changeDetectorRef: ChangeDetectorRef,
    private _currentUser: CurrentUserService,
    private _videoPlayer: VideoPlayerService,
    private _getMeNotified: GetMeNotifiedService,
    private _homeVideoModalService: HomeVideoService,
    private _sessionStorageService: SessionStorageService,
    private _users: UsersService,
    private _walletShared: WalletSharedService,
    public _general: GeneralService
  ) {
    super(_toggler, _router);
    this.checkRoutesForPropertyDetails();
    this.usersInfo = this._currentUser.getUserInfo();
  }

  ngOnInit() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.isLogin = (currentUser && currentUser.isLogin) || false;
    this.checkActiveModule();
    pg.isHorizontalLayout = true;
    this.changeLayout('horizontal-menu');
    this.changeLayout('horizontal-app-menu');
    this._photoGalleryService.update.subscribe(openImageGallery => {
      this.galleryOpen = openImageGallery;
    });

    this._photoViewerService.update.subscribe(openImageViewer => {
      this.viewerOpen = openImageViewer;
    });

    this._videoPlayer.update.subscribe(openVideoPlayer => {
      this.playerOpen = openVideoPlayer;
    });

    this._getMeNotified.update.subscribe(openModal => {
      this.openNotifiedModal = openModal;
    });

    this._homeVideoModalService.update.subscribe(homeModal => {
      this.homeVideoOpen = homeModal;
    });

    this._homeVideoModalService.scrollHidden.subscribe(hideScroll => {
      this.isScrollHidden = hideScroll;
    });
    this.usersInfo = this._currentUser.getUserInfo();
  }

  ngAfterViewInit() {
    this.checkMenuDimensions();
    this.checkViewPorts();
  }

  checkActiveModule() {
    const module = this.activeRouter.snapshot.data.module;
    switch (module) {
      case 'dashboard':
        this.menuItems = {
          left: [
            {
              label: 'My Portfolio',
              routerLink: 'portfolio',
              iconComponentName: ''
            },
            {
              label: 'My Properties',
              routerLink: 'properties',
              iconComponentName: ''
            },
            {
              label: 'My Wallet',
              routerLink: 'wallet',
              iconComponentName: ''
            }
          ],
          right: [
            {
              label: this.usersInfo.fullName,
              routerLink: '/test',
              iconComponentName: 'app-header-user-avatar',
              submenuClass: 'custom-menu',
              submenu: [
                {
                  label: 'My Profile',
                  routerLink: 'my-profile',
                  iconComponentName: 'icon-profile'
                },
                {
                  label: 'Sign out',
                  isLogout: true,
                  iconComponentName: 'icon-logout'
                }
              ]
            }
          ]
        };
        break;
      default:
        this.menuItems = {
          left: [
            {
              label: 'Home',
              routerLink: 'home',
              iconComponentName: ''
            },
            {
              label: 'Properties',
              routerLink: 'properties',
              iconComponentName: ''
            },
            {
              label: 'How It Works',
              submenuClass: 'drop-down',
              submenu: [
                {
                  label: 'How Does It Work',
                  routerLink: '/app/how'
                },
                {
                  label: 'Earning Returns',
                  routerLink: '/app/returns'
                },
                {
                  label: 'Selling Parts',
                  routerLink: '/app/selling-exiting'
                },
                {
                  label: 'Property Management',
                  routerLink: '/app/manage'
                },
                {
                  label: 'Staying',
                  routerLink: '/app/stay-property'
                },
                {
                  label: 'Fees / Costs',
                  routerLink: '/app/our-fees'
                }
              ]
            },
            {
              label: 'Why Invest',
              submenuClass: 'drop-down',
              submenu: [
                {
                  label: 'Why Property',
                  routerLink: '/app/why-invest'
                },
                {
                  label: 'Who It Suits',
                  routerLink: '/app/who'
                },
                {
                  label: 'Compare Options',
                  routerLink: '/app/comparison'
                }
              ]
            },
            {
              label: 'About Partbnb',
              submenuClass: 'drop-down',
              submenu: [
                {
                  label: 'Our Team',
                  routerLink: '/app/about'
                },
                {
                  label: 'Our Marketplace',
                  routerLink: '/app/marketplace'
                },
                {
                  label: 'Our Blog',
                  externalLink: 'https://www.blog.partbnb.com/',
                  target: 'https://www.blog.partbnb.com/'
                },
                {
                  label: 'Offerings',
                  routerLink: '/app/offerings'
                }
              ]
            },
            {
              label: 'Help Center',
              routerLink: 'help',
              iconComponentName: ''
            }
          ],
          right: this.setRightMenu()
        };
    }
  }

  setRightMenu() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.isLogin) {
      return [
        {
          label: this.usersInfo.fullName,
          iconComponentName: 'app-header-user-avatar',
          submenuClass: 'custom-menu',
          submenu: [
            {
              label: 'My Dashboard',
              routerLink: '/dashboard',
              iconComponentName: 'icon-dashboard'
            },
            {
              label: 'My Profile',
              routerLink: 'my-profile',
              iconComponentName: 'icon-profile'
            },
            {
              label: 'Sign out',
              isLogout: true,
              iconComponentName: 'icon-logout'
            }
          ]
        }
      ];
    } else {
      return [
        {
          label: 'Sign In',
          routerLink: '/login',
          iconComponentName: 'icon-user'
        },
        {
          label: 'Sign Up',
          routerLink: '/signup',
          iconComponentName: ''
        }
      ];
    }
  }

  // ngOnDestroy() {
  //   this.moduleChecker.unsubscribe();
  // }

  checkRoutesForPropertyDetails() {
    this._router.events.subscribe(event => {
      if (event instanceof ActivationEnd && event.snapshot.data.pageName) {
        switch (event.snapshot.data.pageName) {
          case 'Property':
            this.resetButtons();
            this.propertyDetailsInit();
            break;
          case 'My Wallet':
            this.resetButtons();
            this.isWalletButtonShow = true;
            break;
          case 'My Properties':
            this.resetButtons();
            this.isAddPropertyButtonShow = true;
            break;
          default:
            this.resetButtons();
        }
      }
    });
  }

  resetButtons() {
    this.isPreOrderButtonShow = false;
    this.isWalletButtonShow = false;
    this.isAddPropertyButtonShow = false;
  }

  propertyDetailsInit() {
    this.isNotAllow = false;
    this.isDetailsReady = false;
    this.isPreOrderButtonShow = true;
    this._propertyShared.setPropertyDetails(this.isPreOrderButtonShow);

    this._propertyShared.getPropertyDetails().then(data => {
      this.details = data;
      this.propertyId = data.propertyId;
      this.isDetailsReady = !!(data && data.propertyId);
      if (data.propertyListingTypeId !== PROPERTY_STATUS.LIVE) {
        this.checkProperty(data.propertyId);
      }
    });
  }

  propertyDetailsButton() {
    return this.details.propertyListingTypeId === PROPERTY_STATUS.LIVE
      ? `Order Now from $${this.details.pricePerPart}`
      : 'Pre-Order Now';
  }

  propertyDetailsButtonIfNotLogin() {
    return this.details.propertyListingTypeId === PROPERTY_STATUS.LIVE
      ? 'Create Account to Buy Parts'
      : 'Create Account to Pre-order';
  }

  checkProperty(propertyId: number) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};
    if (propertyId && currentUser.isLogin) {
      this._users
        .checkUserForPreOrder(currentUser.username, propertyId)
        .subscribe(res => {
          this.isNotAllow = !(res && res.canPreOrder);
        });
    }
  }

  preOrder() {
    if (!this.isLogin) {
      this._router.navigate([`/signup`], {
        queryParams: {
          returnUrl: this._router.url.toString()
        }
      });
      return;
    }
    if (this.details.propertyListingTypeId !== PROPERTY_STATUS.LIVE) {
      this._router.navigate([`/preorder/${this.propertyId}`]);
      return;
    }
    const { verificationStatus } = this._currentUser.getUserInfo();
    if (verificationStatus === VERIFICATION_STATUS.APPROVED) {
      const details = {
        ...this.details
      };
      const modalRef = this.modalService.show(OrderPropertyModalComponent, {
        initialState: { details },
        animated: false,
        class: 'centered-modal'
      });
    } else {
      const props: ConfirmationProps = {
        status: 'warning',
        title: 'You need to be verified as an Accredited Investor',
        desc: `We need to verify your status as an Accredited Investor before you can proceed.`,
        isButtonDisabled:
          verificationStatus === VERIFICATION_STATUS.PENDING || false,
        buttonLabel:
          verificationStatus === VERIFICATION_STATUS.PENDING
            ? 'Verification Pending'
            : 'Start Verification'
      };
      const modalRef = this.modalService.show(ConfirmationComponent, {
        initialState: { props },
        animated: false,
        class: 'confirmation'
      });
      (<ConfirmationComponent>modalRef.content).onClose.subscribe(result => {
        if (result) {
          this.openInvestorVerify();
        }
      });
    }
  }

  openInvestorVerify() {
    const modalRef = this.modalService.show(InvestorVerificationComponent, {
      ignoreBackdropClick: true,
      class: 'modal-lg'
    });
  }

  addFund() {
    this._walletShared.toggle(true);
    const modalRef = this.modalService.show(AddFundsComponent, {
      initialState: {},
      animated: false,
      class: 'plaid-modal'
    });
    (<AddFundsComponent>modalRef.content).onClose.subscribe(result => {
      if (result === 'done') {
        this._walletShared.toggle(false);
      }
    });
  }

  checkViewPorts() {
    this.desktopView = window.outerWidth > this.tabletViewMaxSize;
    this.tabletView =
      window.outerWidth <= this.tabletViewMaxSize &&
      window.outerWidth > this.tabletViewMinSize;
    this.mobileView = window.outerWidth <= this.tabletViewMinSize;
    // if (window.innerWidth <= this.tabletViewMinSize) {
    //   this.header.style = null;
    // }
    this.header.style = null;
    this.changeDetectorRef.detectChanges();
  }

  checkMenuDimensions() {
    this.header = document.querySelector('#header-container');
    this.menuBar = document.querySelector('.menu-bar');
    this.logoContainer = document.querySelector('.header-inner');
    this.headerHeight = this.header.clientHeight;
    this.menuBarHeight = this.menuBar.clientHeight;
    this.logoContainerHeight = this.logoContainer.clientHeight;
    if (this.headerHeight) {
      // this.header.style.height = `${this.headerHeight}px`;
      this.header.style.height = `101px`;
    }
  }
}
